import { FC, useMemo } from 'react'
import { KeyValuePairs } from '@aws-northstar/ui'
import {
	ColumnLayout,
	Container,
	Header,
} from '@cloudscape-design/components'

import type { Platform } from '../../../types/platforms'
import useApprovedGcpProjectsWithTags from '../../../hooks/query/useApprovedGcpProjectsWithTags'

interface ApprovalDetailsProps {
	approvalDetails: Platform
}

const ApprovalDetails: FC<ApprovalDetailsProps> = ({ approvalDetails }) => {

	const { data: gcpProjectsList} = useApprovedGcpProjectsWithTags()

	const jsonDataString = JSON.stringify(approvalDetails)
	const jsonData = JSON.parse(jsonDataString)

	const projectFound = useMemo(() => {

	return gcpProjectsList?.find((project) => (
		approvalDetails.gcpProjectID === project.tags?.details?.projectName
	))

	},[gcpProjectsList, approvalDetails.gcpProjectID])

	

	const generalDetailsKeyValuePairsItems = [
		[{ label: 'Platform Cluster Name', value: jsonData.namePrefix }],
		[
			{
				label: 'Network Project ID',
				value: jsonData.networkProjectID
			}
		],
		[{ label: 'VPC Name', value: jsonData.network }],
		[{ label: 'Subnet Name', value: jsonData.subnetwork }],
		[
			{
				label: 'Control Plane Range',
				value: jsonData.controlPlaneRange
			}
		],
		[
			{
				label: 'Node Subnet Range',
				value: jsonData.subnetworkRange
			}
		],
		[
			{
				label: 'Name of Secondary Ranges for Pods',
				value: jsonData.ipRangePods
			}
		],
		[
			{
				label: 'CIDR Block of Secondary Ranges for Pods',
				value: projectFound?.details?.secondaryPodsRange
			}
		],
		[
			{
				label: 'Name of Secondary Ranges for Services',
				value: jsonData.ipRangeServices
			}
		],
		[
			{
				label: 'CIDR Block of Secondary Ranges for Services',
				value: projectFound?.details?.secondaryServicesRange
			}
		]
	]

	return (
		
		<Container>
			<Header variant="h3">Provisioning Details</Header>
			<ColumnLayout columns={3} variant="text-grid">
				<KeyValuePairs
					key={'generalDetails'}
					items={generalDetailsKeyValuePairsItems}
				/>
			</ColumnLayout>
		</Container>

	)
}

export default ApprovalDetails
